export default __webpack_public_path__ + "static/media/Hipercard.ae9f4ba6.svg";